import moment from 'moment';

export const getTimeErrors = horarios => {
    let error = false;

    horarios.forEach(item => {
        // Validação do horário principal
        if (item.aberto) {
            if (!item.horario) {
                error = `O horário de ${item.diaSemana} deve estar no formato HH:mm - HH:mm`;
                return;
            }

            let horarios = item.horario.split(' - ');
            if (horarios.length !== 2) {
                error = `O horário de ${item.diaSemana} deve estar no formato HH:mm - HH:mm`;
            }

            let horarioValido = horarios.every(horario => moment(horario, 'HH:mm', true).isValid());
            if (!horarioValido) {
                error = `Os horários de ${item.diaSemana} devem estar no formato HH:mm e serem válidos`;
            }

            let horarioInicial = moment(horarios[0], 'HH:mm');
            let horarioFinal = moment(horarios[1], 'HH:mm');
            if (!horarioInicial.isBefore(horarioFinal)) {
                error = `O horário de ${item.diaSemana} deve estar entre 00:00 e 23:59`;
            }
        }

        // Validação do segundo horário, se ativo
        if (item.segundoHorarioAtivo) {
            if (!item.segundoHorario) {
                error = `O segundo horário de ${item.diaSemana} deve estar no formato HH:mm - HH:mm`;
                return;
            }

            let horarios = item.segundoHorario.split(' - ');
            if (horarios.length !== 2) {
                error = `O segundo horário de ${item.diaSemana} deve estar no formato HH:mm - HH:mm`;
            }

            let segundoHorarioValido = horarios.every(horario => moment(horario, 'HH:mm', true).isValid());
            if (!segundoHorarioValido) {
                error = `Os horários do segundo horário de ${item.diaSemana} devem estar no formato HH:mm e serem válidos`;
            }

            let horarioInicial = moment(horarios[0], 'HH:mm');
            let horarioFinal = moment(horarios[1], 'HH:mm');
            if (!horarioInicial.isBefore(horarioFinal)) {
                error = `O horário inicial do segundo horário de ${item.diaSemana} deve estar entre 00:00 e 23:59`;
            }
        }
    });

    return error;
};

export const limparDocumento = valor => String(valor ?? '').replace(/[^0-9a-zA-Z]/g, '').toUpperCase();

export const isValidCpf = valor => {
    const cpf = limparDocumento(valor);

    if (!/^\d{11}$/.test(cpf) || /^(\d)\1+$/.test(cpf)) {
        return false;
    }

    for (let tamanho = 9; tamanho < 11; tamanho++) {
        let soma = 0;

        for (let i = 0; i < tamanho; i++) {
            soma += Number(cpf[i]) * (tamanho + 1 - i);
        }

        if ((soma * 10) % 11 % 10 !== Number(cpf[tamanho])) {
            return false;
        }
    }

    return true;
}

export const isValidCnpj = valor => {
    const cnpj = limparDocumento(valor);

    if (!/^[0-9A-Z]{12}\d{2}$/.test(cnpj) || /^(.)\1+$/.test(cnpj)) {
        return false;
    }

    for (let tamanho = 12; tamanho < 14; tamanho++) {
        let soma = 0;
        let peso = 2;

        for (let i = tamanho - 1; i >= 0; i--) {
            soma += (cnpj.charCodeAt(i) - 48) * peso;
            peso = peso === 9 ? 2 : peso + 1;
        }

        const resto = soma % 11;

        if ((resto < 2 ? 0 : 11 - resto) !== Number(cnpj[tamanho])) {
            return false;
        }
    }

    return true;
}

export const isValidCpfCnpj = valor => {
    const documento = limparDocumento(valor);

    return documento.length === 11 ? isValidCpf(documento) : isValidCnpj(documento);
}

// Máscaras para o v-mask (vue-the-mask): "C" aceita letra ou número e põe em
// maiúscula, para o CNPJ alfanumérico. No campo único, a parte de CPF também
// usa "C" — senão a letra digitada nas 11 primeiras posições seria descartada
// antes de a máscara trocar para a de CNPJ.
const TOKENS_DOCUMENTO = {
    '#': {pattern: /\d/},
    'C': {pattern: /[0-9a-zA-Z]/, transform: v => v.toLocaleUpperCase()},
};

export const MASCARA_CNPJ = {mask: 'CC.CCC.CCC/CCCC-##', tokens: TOKENS_DOCUMENTO};

export const MASCARA_CPF_CNPJ = {mask: ['CCC.CCC.CCC-CC', 'CC.CCC.CCC/CCCC-##'], tokens: TOKENS_DOCUMENTO};

export const isValidEmail = email => {
    const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailPattern.test(email);
}

export const isValidCep = cep => {
    const cepPattern = /^[0-9]{8}$/;
    return cepPattern.test(cep?.replace(/\D/g, ''));
}

export const SENHA_REGRA = 'A senha deve ter no mínimo 8 caracteres, com pelo menos 1 letra e 1 número';

export const getPasswordError = password => {
    if (typeof password !== 'string' || password.length < 8) {
        return SENHA_REGRA;
    }

    if (!/[a-zA-ZÀ-ÿ]/.test(password) || !/\d/.test(password)) {
        return SENHA_REGRA;
    }

    return false;
};

export const isValidPersonName = name => {
    if (!name || typeof name !== 'string') {
        return false;
    }

    const words = name.trim().split(/\s+/);

    return words.length >= 2;
}

export const getTimeFieldError = (valor, nomeCampo) => {

    const campo = nomeCampo === 'segundoHorario' ? 'Segundo Horário' : 'Horário';

    if (!valor) {
        return `O ${campo} está vazio.`;
    }

    if (!valor || typeof valor !== 'string' || !valor.trim()) {
        return `O ${campo} deve estar no formato HH:mm - HH:mm`;
    }

    const time = /^([01]\d|2[0-3]):([0-5]\d)\s*-\s*([01]\d|2[0-3]):([0-5]\d)$/;
    const m = valor.match(time);
    if (!m) {
        return `O ${campo} deve estar no formato HH:mm - HH:mm (ex.: 08:00 - 17:30)`;
    }

    const h1 = Number(m[1]), m1 = Number(m[2]);
    const h2 = Number(m[3]), m2 = Number(m[4]);
    const ini = h1 * 60 + m1;
    const fim = h2 * 60 + m2;

    if (ini >= fim) {
        return `O ${campo} deve ter início antes do fim (entre 00:00 e 23:59)`;
    }

    return false; // valido
};
